import { VariantProps } from 'tailwind-variants';

import { SheetContent } from '@/components/ui/sheet';

export enum ProgressiveModalDefaultKeys {
  CLOSE = 'CLOSE',
}

export enum ProgressiveModalDirectionKeys {
  left = 'left',
  right = 'right',
  center = 'center',
}

export interface JumpProps<T> {
  key: T | ProgressiveModalDefaultKeys;
  returning?: boolean;
}

export type JumpFC<T> = (props: JumpProps<T>) => void;

export interface ProgressiveModalSetOpenProps {
  open: boolean;
  currentKey?: string;
  handleJump?: (props: JumpProps<string>) => void;
}

export interface ProgressiveProps<T> {
  jump?: (props: JumpProps<T>) => void;
}

export interface ProgressiveModalEventHandlerProps {
  handleJump: JumpFC<string>;
  currentKey: string;
  event: Event;
}

interface SharedTypesProgressiveModal
  extends Partial<Omit<React.ElementRef<typeof SheetContent>, 'children' | 'className'>> {
  open: boolean;
  className?: string;
  initialKey: string;
  scrollable?: boolean;
  hasHeader?: boolean;
  contentPadding?: boolean;
  onKeyChange?: (key: string) => void;
  onInteractOutside?: (props: ProgressiveModalEventHandlerProps) => void;
  onOpenAutoFocus?: (props: ProgressiveModalEventHandlerProps) => void;
  onCloseAutoFocus?: (props: ProgressiveModalEventHandlerProps) => void;
  onEscapeKeyDown?: (props: ProgressiveModalEventHandlerProps) => void;
  sheetSide?: VariantProps<typeof SheetContent>['side'];
}

export interface ProvidedProgressiveModalProps extends SharedTypesProgressiveModal {
  children: React.ReactNode;
  slideDirection: ProgressiveModalDirectionKeys;
  description?: string;
  onExitComplete: () => void;
}

export interface ProgressiveModalProps extends SharedTypesProgressiveModal {
  children: React.ReactNode[];
  description?: string;
  handleClose: (props: Omit<ProgressiveModalEventHandlerProps, 'event'>) => void;
}

export interface UseProgressiveModalHookTypes<T> {
  handleJump: JumpFC<T>;
  currentKey: string;
  renderKey: number;
  onClose: () => void;
}
